import { RootState } from '~/stores';

export const isolateUserAccounts = (s: RootState) => s.user.accounts;


